import React from "react";

const platforms = [
  { name: "Canal+", logo: "/logos/logo-canal-plus-tv.webp" },
  { name: "beIN Sports", logo: "/logos/logo-bein-sports.webp" },
  { name: "Prime Video", logo: "/logos/logo-amazon-prime-video.webp" },
  { name: "Netflix", logo: "/logos/logo-netflix-streaming.webp" },
  { name: "Disney+", logo: "/logos/logo-disney-plus-streaming.webp" },
  { name: "DAZN", logo: "/logos/logo-dazn-sport.webp" },
  { name: "Ligue 1", logo: "/logos/logo-ligue-1-football.webp" },
  { name: "Paramount+", logo: "/logos/logo-paramount-plus.webp" },
  { name: "HBO", logo: "/logos/logo-hbo-max-streaming.webp" },
  { name: "Apple TV+", logo: "/logos/logo-apple-tv-plus.webp" },
];

const PlatformsSection = () => {
  return (
    <section className="py-8 md:py-12 bg-background overflow-hidden">
      <div className="container mx-auto px-4 mb-6 md:mb-8">
        <h2 className="text-xl sm:text-2xl md:text-4xl font-bold text-center">
          Tous Vos Abonnements IPTV Réunis Dans Une{" "}
          <span className="text-primary">Seule Offre !</span>
        </h2>
      </div>

      {/* Marquee container */}
      <div className="relative w-full">
        {/* Gradient overlays for smooth fade effect */}
        <div className="absolute left-0 top-0 bottom-0 w-12 md:w-20 bg-gradient-to-r from-background to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-12 md:w-20 bg-gradient-to-l from-background to-transparent z-10" />

        {/* Scrolling wrapper */}
        <div className="flex overflow-hidden">
          {/* First set of logos */}
          <div className="flex animate-scroll shrink-0">
            {platforms.map((platform, index) => (
              <div
                key={`first-${platform.name}-${index}`}
                className="flex-shrink-0 mx-4 md:mx-6 lg:mx-10"
              >
                <img
                  src={platform.logo}
                  alt={platform.name}
                  width={80}
                  height={80}
                  loading="lazy"
                  decoding="async"
                  className="h-12 md:h-16 lg:h-20 w-auto object-contain"
                />
              </div>
            ))}
          </div>

          {/* Duplicate set for seamless loop */}
          <div className="flex animate-scroll shrink-0">
            {platforms.map((platform, index) => (
              <div
                key={`second-${platform.name}-${index}`}
                className="flex-shrink-0 mx-4 md:mx-6 lg:mx-10"
              >
                <img
                  src={platform.logo}
                  alt={platform.name}
                  width={80}
                  height={80}
                  loading="lazy"
                  decoding="async"
                  className="h-12 md:h-16 lg:h-20 w-auto object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlatformsSection;
